import { formatPrice } from '@commerce/product/use-price'
import { useCommerce } from '@framework'
import { NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_CURRENCY } from '@utils/client-side-config'

export function TotalPriceSection({ price }: { price: number }) {
  const { locale } = useCommerce()
  const formattedPrice = formatPrice({
    amount: price,
    currencyCode: NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_CURRENCY,
    locale: locale,
  })

  return (
    <div className="flex flex-col gap-2 mb-10">
      <h5 className="flex justify-between font-mori font-bold text-[16px] text-acai">
        <span>Total (excl. VAT)</span>
        <span>{formattedPrice}</span>
      </h5>

      <p className="text-xl font-mori text-acai max-w-[60%]">
        Free standard shipping & proofing available on all orders
      </p>
    </div>
  )
}
